import type { BreathingPatternId } from './breathingPatterns';

export type BreatheStatus = 'idle' | 'running' | 'done';
export type BreatheLength = '1' | '2' | '3';
/** The answer to "How do you feel now?" after a session. */
export type BreatheFeeling = 'calmer' | 'same' | 'tense';

/** What the Breathe page remembers between visits, on this device. */
export interface BreathePrefs {
  pattern: BreathingPatternId;
  length: BreatheLength;
  /** The soft tone (and buzz on phones) at each change of breath. */
  sound: boolean;
}

export const DEFAULT_BREATHE_PREFS: BreathePrefs = {
  pattern: 'cyclic',
  length: '1',
  sound: false,
};
